import {
    Box,
    Flex,
    SimpleGrid,
    Spinner,
    Text,
} from "@chakra-ui/react";

import {
    useEffect,
    useState,
} from "react";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import {
    useNavigate,
} from "react-router-dom";

import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/Topbar";

import PageHeader from "../Dashboard/components/PageHeader";

import PolicyCard from "./components/PolicyCard";
import TermsPoliciesSkeleton from "./components/TermsPoliciesSkeleton";

import {
    fetchPoliciesAction,
} from "../../state/actions/policyActions";

import routes from "../../routes";

const TermsAndPolicies = () => {
    const dispatch =
        useDispatch();
    const [showSkeleton, setShowSkeleton] =
    useState(true);
    const navigate =
        useNavigate();

    const {
        policies,
        loading,
    } = useSelector(
        (
            state
        ) =>
            state.policy
    );

    useEffect(() => {
        dispatch(fetchPoliciesAction());

        const timer = setTimeout(() => {
            setShowSkeleton(false);
        }, 3000);

        return () => clearTimeout(timer);
    }, [dispatch]);


const allowedPolicies = [
    "Mogoma Driver Partner Programme Terms & Conditions",

    "Mogoma Driver Partner Programme Privacy Policy",

    "Mogoma Driver Partner Programme Payments, Wallet & Settlement Policy",

    "Mogoma Driver Partner Programme Commission & Payout Policy",

    "Mogoma Driver Partner Programme Code of Conduct",

    "Mogoma Driver Partner Programme Anti-Fraud & Compliance Policy",
];

    const displayPolicies =
        policies
            .filter(
                (
                    policy
                ) =>
                    allowedPolicies.includes(
                        policy.title
                    )
            )
            .map(
                (
                    policy
                ) => ({
                    ...policy,

                    displayTitle:
                        policy.title.startsWith(
                            "Mogoma Driver Partner Programme "
                        )
                            ? policy.title.replace(
                                  "Mogoma Driver Partner Programme ",
                                  ""
                              )
                            : policy.title,
                })
            );
    
    if (showSkeleton) {
    return (
       <Flex
    h="100vh"
    bg="#F8FAFC"
    overflow="hidden"
    marginBottom={{
        base: 20,
        md: 0,
    }}
>
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
                overflow="hidden"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <TermsPoliciesSkeleton />
                </Box>
            </Flex>
        </Flex>
    );
}

    return (
       <Flex
    h="100vh"
    bg="#F8FAFC"
    overflow="hidden"
    marginBottom={{
        base: 20,
        md: 0,
    }}
>
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
                overflow="hidden"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <PageHeader
                        title="Terms & Policies"
                        subtitle="Review the policies, legal agreements and programme rules that govern your participation as a Mogoma Partner."
                    />

                    
                        <SimpleGrid
                            columns={{
                                base: 1,
                                md: 2,
                                xl: 3,
                            }}
                            gap={6}
                        >
                            {displayPolicies.map(
                                (
                                    policy
                                ) => (
                                    <PolicyCard
                                        key={
                                            policy.id
                                        }
                                        policy={{
                                            ...policy,
                                            title:
                                                policy.displayTitle,
                                        }}
                                        onClick={() =>
                                            navigate(
                                                routes.policyDetails.replace(
                                                    ":id",
                                                    policy.id
                                                ),
                                                {
                                                    state:
                                                        {
                                                            policy,
                                                        },
                                                }
                                            )
                                        }
                                    />
                                )
                            )}
                        </SimpleGrid>
                
                </Box>
            </Flex>
        </Flex>
    );
};

export default TermsAndPolicies;